module.exports = {
	"header": "The future of hard copy books market: challenges, opportunities and… a Scandinavian solution",
	"date": "2023/01/10",
	"imgSrc": "22.png",
	"imgAlt": "The future of hard copy books market: challenges, opportunities and… a Scandinavian solution",
	"ingress": "By: Modern Retail UK",
	"externalLink": "https://modernretail.co.uk/the-future-of-hard-copy-books-market-challenges-opportunities-and-a-scandinavian-solution/"
};


//////////////////
// WEBPACK FOOTER
// ./pages/media/22/article.json
// module id = 92
// module chunks = 0